/* ══════════════════════════════════════════════════════════════
   BRUTECH CUSTOM JS — Impact Theme
   Rebuilt from scratch. Mobile-safe, theme-editor-safe.
   Rules: no textContent/innerHTML on product-card elements,
   no synchronous heavy processing, safe MutationObservers.
══════════════════════════════════════════════════════════════ */

/* ── SHARED DATA ── */
var RARITY_ORDER_DESC = ['mythical','mythic','eldritch','celestial','divine','mystic','legendary','epic','rare','uncommon','common'];
var RARITY_TIERS = ['common','uncommon','rare','epic','legendary','mystic','divine','celestial','eldritch','mythic','mythical'];
var RARITY_LABELS = { common:'◆ COMMON', uncommon:'◆ UNCOMMON', rare:'◆ RARE', epic:'◆ EPIC', legendary:'◆ LEGENDARY', mystic:'◆ MYSTIC', divine:'◆ DIVINE', celestial:'◆ CELESTIAL', eldritch:'◆ ELDRITCH', mythic:'◆ MYTHIC', mythical:'★ MYTHICAL' };
var RARITY_PROFILES = {
  common:    { bestFor:'Entry Gaming',   target:'1080p',        value:'ENTRY VALUE',   tierScore:10, gpuFallback:'RTX 5050',    cpuFallback:'Core Ultra 5 225F' },
  uncommon:  { bestFor:'1080p Gaming',   target:'1080p High',   value:'1080p VALUE',   tierScore:20, gpuFallback:'RTX 5060',    cpuFallback:'Core Ultra 5 225F' },
  rare:      { bestFor:'1440p Gaming',   target:'1440p High',   value:'STRONG VALUE',  tierScore:30, gpuFallback:'RTX 5060 Ti', cpuFallback:'Core Ultra 5 225F' },
  epic:      { bestFor:'1440p Ultra',    target:'1440p / 4K',   value:'BEST VALUE+',   tierScore:40, gpuFallback:'RTX 5060 Ti', cpuFallback:'Core Ultra 5 250K+' },
  legendary: { bestFor:'4K Gaming',      target:'4K High',      value:'PREMIUM POWER', tierScore:50, gpuFallback:'RTX 5070',    cpuFallback:'Core Ultra 5 250K+' },
  mystic:    { bestFor:'4K Ultra',       target:'4K Ultra',     value:'ELITE PICK',    tierScore:60, gpuFallback:'RTX 5070',    cpuFallback:'Core Ultra 7 270K+' },
  divine:    { bestFor:'Extreme 4K',     target:'4K Ultra / AI',value:'S-TIER VALUE',  tierScore:70, gpuFallback:'RX 9070 XT',  cpuFallback:'Core Ultra 7 270K+' },
  celestial: { bestFor:'Creator + 4K',   target:'4K / Studio',  value:'ULTRA CLASS',   tierScore:80, gpuFallback:'RTX 5070 Ti', cpuFallback:'Core Ultra 7 270K+' },
  eldritch:  { bestFor:'Extreme Power',  target:'4K / AI',      value:'EXTREME PICK',  tierScore:90, gpuFallback:'RTX 5070 Ti', cpuFallback:'Ryzen 7 9850X3D' },
  mythic:    { bestFor:'Endgame Gaming', target:'4K Max',       value:'ENDGAME PICK',  tierScore:95, gpuFallback:'RTX 5080',    cpuFallback:'Core Ultra 7 270K+' },
  mythical:  { bestFor:'Legend Class',   target:'4K Ultra Max', value:'LEGEND TIER',   tierScore:100,gpuFallback:'RTX 5090',    cpuFallback:'Ryzen 9 9950X3D' }
};
var GPU_RULES = [
  { re:/\brtx\s*5090\b/i, score:100, display:'RTX 5090',    target:'4K Ultra / AI', bestFor:'Extreme 4K' },
  { re:/\brtx\s*5080\b/i, score:89,  display:'RTX 5080',    target:'4K Ultra',      bestFor:'4K Gaming' },
  { re:/\brtx\s*5070\s*ti\b|\brtx\s*5070ti\b/i, score:78, display:'RTX 5070 Ti', target:'1440p / 4K', bestFor:'1440p Ultra' },
  { re:/\brtx\s*5070\b/i, score:68,  display:'RTX 5070',    target:'1440p High',    bestFor:'1440p Gaming' },
  { re:/\brtx\s*5060\s*ti\b|\brtx\s*5060ti\b/i, score:59, display:'RTX 5060 Ti', target:'1080p / 1440p', bestFor:'1080p Ultra' },
  { re:/\brtx\s*5060\b/i, score:51,  display:'RTX 5060',    target:'1080p High',    bestFor:'1080p Gaming' },
  { re:/\brtx\s*5050\b/i, score:42,  display:'RTX 5050',    target:'1080p',         bestFor:'Entry Gaming' },
  /* NVIDIA RTX PRO Blackwell (workstation) */
  { re:/\brtx\s*pro\s*5000\b/i, score:87, display:'RTX PRO 5000', target:'Pro Compute / 4K', bestFor:'AI / Pro Workload' },
  { re:/\brtx\s*pro\s*4500\b/i, score:76, display:'RTX PRO 4500', target:'Pro Compute',       bestFor:'Pro Rendering' },
  { re:/\brtx\s*pro\s*4000\b/i, score:70, display:'RTX PRO 4000', target:'Pro Compute',       bestFor:'Pro Workstation' },
  /* RTX 4000 series */
  { re:/\brtx\s*4090\b/i, score:93,  display:'RTX 4090',    target:'4K Ultra',      bestFor:'Extreme 4K' },
  { re:/\brtx\s*4080\s*super\b/i, score:84, display:'RTX 4080 Super', target:'4K High', bestFor:'4K Gaming' },
  { re:/\brtx\s*4080\b/i, score:82,  display:'RTX 4080',    target:'4K High',       bestFor:'4K Gaming' },
  { re:/\brtx\s*4070\s*ti\s*super\b/i, score:75, display:'RTX 4070 Ti Super', target:'1440p / 4K', bestFor:'1440p Ultra' },
  { re:/\brtx\s*4070\s*ti\b|\brtx\s*4070ti\b/i, score:72, display:'RTX 4070 Ti', target:'1440p / 4K', bestFor:'1440p Ultra' },
  { re:/\brtx\s*4070\s*super\b/i, score:67, display:'RTX 4070 Super', target:'1440p High', bestFor:'1440p Gaming' },
  { re:/\brtx\s*4070\b/i, score:63,  display:'RTX 4070',    target:'1440p High',    bestFor:'1440p Gaming' },
  { re:/\brtx\s*4060\s*ti\b|\brtx\s*4060ti\b/i, score:55, display:'RTX 4060 Ti', target:'1080p / 1440p', bestFor:'1080p Ultra' },
  { re:/\brtx\s*4060\b/i, score:47,  display:'RTX 4060',    target:'1080p High',    bestFor:'1080p Gaming' },
  { re:/\brtx\s*4050\b/i, score:38,  display:'RTX 4050',    target:'1080p',         bestFor:'1080p Gaming' },
  /* AMD RX */
  { re:/\brx\s*9070\s*xt\b/i, score:82, display:'RX 9070 XT', target:'1440p / 4K', bestFor:'1440p Ultra' },
  { re:/\brx\s*9070\b/i, score:74,   display:'RX 9070',     target:'1440p High',    bestFor:'1440p Gaming' },
  { re:/\brx\s*7900\s*xtx\b/i, score:86, display:'RX 7900 XTX', target:'4K High',  bestFor:'4K Gaming' },
  { re:/\brx\s*7800\s*xt\b/i, score:65,  display:'RX 7800 XT',  target:'1440p High', bestFor:'1440p Gaming' },
  { re:/\brx\s*7600\b/i, score:43,   display:'RX 7600',     target:'1080p',         bestFor:'1080p Gaming' }
];
/* ──────────────────────────────────────────────────────────────────────────
   CPU_RULES — dual-axis scoring (0-100)
   ----------------------------------------------------------------------------
   score        = GAMING / FPS index.  Basis: 3DMark CPU Profile (8-thread,
                  the gaming-relevant result) + real-game FPS averages.
                  This is the field the FPS calculator + rarity buildScore read.
   creatorScore = CONTENT-CREATION index.  Basis: Cinebench 2024 nT +
                  Blender / Premiere-style multi-thread render throughput.
                  Read this on Creator / Threadripper / Workstation cards.

   Why two numbers: gaming is bound by single-thread + cache (X3D & high-clock
   Intel win); creation is bound by thread throughput (Threadripper & high
   core-count chips win). A single score can't represent both without lying
   about one of them — which is exactly how the 225F/8700F/250K+ got skewed.
   ────────────────────────────────────────────────────────────────────────── */
var CPU_RULES = [
  /* AMD Ryzen Threadripper (HEDT / workstation) — creation kings, mid gaming */
  { re:/\bthreadripper\s*9980x\b/i, score:72, creatorScore:100, display:'Threadripper 9980X' },
  { re:/\bthreadripper\s*9970x\b/i, score:71, creatorScore:97,  display:'Threadripper 9970X' },
  { re:/\bthreadripper\s*9960x\b/i, score:70, creatorScore:94,  display:'Threadripper 9960X' },
  /* AMD Ryzen desktop */
  { re:/\bryzen\s*9\s*9950x3d\b/i, score:98, creatorScore:92, display:'Ryzen 9 9950X3D' },
  { re:/\bryzen\s*9\s*9950x\b/i,   score:82, creatorScore:91, display:'Ryzen 9 9950X' },
  { re:/\bryzen\s*9\s*9900x3d\b/i, score:93, creatorScore:84, display:'Ryzen 9 9900X3D' },
  { re:/\bryzen\s*7\s*9850x3d\b/i, score:96, creatorScore:74, display:'Ryzen 7 9850X3D' },
  { re:/\bryzen\s*7\s*9800x3d\b/i, score:95, creatorScore:72, display:'Ryzen 7 9800X3D' },
  { re:/\bryzen\s*9\s*9900x\b/i,   score:78, creatorScore:83, display:'Ryzen 9 9900X' },
  { re:/\bryzen\s*7\s*9700x\b/i,   score:77, creatorScore:66, display:'Ryzen 7 9700X' },
  { re:/\bryzen\s*5\s*9600x\b/i,   score:74, creatorScore:54, display:'Ryzen 5 9600X' },
  { re:/\bryzen\s*5\s*7600\b/i,    score:58, creatorScore:50, display:'Ryzen 5 7600' },
  /* AMD Ryzen 8000 desktop (Zen 4) — explicit so they stop hitting the generic fallback */
  { re:/\bryzen\s*7\s*8700g\b/i,   score:61, creatorScore:58, display:'Ryzen 7 8700G' },
  { re:/\bryzen\s*7\s*8700f?\b/i,  score:61, creatorScore:58, display:'Ryzen 7 8700F' },
  /* AMD Ryzen mobile HX/HS */
  { re:/\bryzen\s*9\s*8945hx\b/i,  score:80, creatorScore:89, display:'Ryzen 9 8945HX' },
  { re:/\bryzen\s*9\s*7945hx\b/i,  score:77, creatorScore:86, display:'Ryzen 9 7945HX' },
  { re:/\bryzen\s*7\s*8845hs\b/i,  score:70, creatorScore:70, display:'Ryzen 7 8845HS' },
  { re:/\bryzen\s*7\s*7745hx\b/i,  score:68, creatorScore:68, display:'Ryzen 7 7745HX' },
  { re:/\bryzen\s*5\s*8645hs\b/i,  score:56, creatorScore:55, display:'Ryzen 5 8645HS' },
  { re:/\bryzen\s*5\s*7535hs\b/i,  score:50, creatorScore:47, display:'Ryzen 5 7535HS' },
  { re:/\bryzen\s*5\s*7530u\b/i,   score:44, creatorScore:42, display:'Ryzen 5 7530U' },
  /* Intel Core Ultra desktop K-series */
  { re:/\bcore\s*ultra\s*9\s*285k/i, score:83, creatorScore:90, display:'Core Ultra 9 285K' },
  { re:/\bcore\s*ultra\s*7\s*270k/i, score:85, creatorScore:82, display:'Core Ultra 7 270K+' },
  { re:/\bcore\s*ultra\s*7\s*265k/i, score:74, creatorScore:80, display:'Core Ultra 7 265K' },
  { re:/\bcore\s*ultra\s*5\s*250k/i, score:79, creatorScore:72, display:'Core Ultra 5 250K+' },
  { re:/\bcore\s*ultra\s*5\s*245k/i, score:70, creatorScore:64, display:'Core Ultra 5 245K' },
  { re:/\bcore\s*ultra\s*5\s*225/i,  score:62, creatorScore:52, display:'Core Ultra 5 225F' },
  /* Intel Core Ultra H-series (mobile) */
  { re:/\bcore\s*ultra\s*9\s*285h/i, score:74, creatorScore:78, display:'Core Ultra 9 285H' },
  { re:/\bcore\s*ultra\s*7\s*258h/i, score:70, creatorScore:72, display:'Core Ultra 7 258H' },
  { re:/\bcore\s*ultra\s*7\s*255h/i, score:68, creatorScore:70, display:'Core Ultra 7 255H' },
  { re:/\bcore\s*ultra\s*7\s*240h/i, score:63, creatorScore:64, display:'Core Ultra 7 240H' },
  { re:/\bcore\s*ultra\s*5\s*230h/i, score:56, creatorScore:54, display:'Core Ultra 5 230H' },
  { re:/\bcore\s*ultra\s*5\s*210h/i, score:50, creatorScore:48, display:'Core Ultra 5 210H' },
  /* Generic Ryzen fallbacks — must be LAST, catch any Ryzen not matched above */
  { re:/\bryzen\s*9\b/i, score:78, creatorScore:80, display:'Ryzen 9' },
  { re:/\bryzen\s*7\b/i, score:60, creatorScore:60, display:'Ryzen 7' },
  { re:/\bryzen\s*5\b/i, score:50, creatorScore:48, display:'Ryzen 5' },
  { re:/\bryzen\s*3\b/i, score:33, creatorScore:30, display:'Ryzen 3' }
];

/* ── SHARED UTILITIES ── */

/* SAFE card source reader. NEVER reads textContent/innerHTML on
   <product-card> — those contain 50-100KB of variant JSON and crash
   mobile tabs. Reads only specific targeted attributes. */
function brtGetSrc(card) {
  if (card._bsrc) return card._bsrc;
  var p = [];
  var ATTRS = ['class','data-tags','data-product-tags','handle','data-handle','aria-label','title'];
  for (var i = 0; i < ATTRS.length; i++) { var v = card.getAttribute(ATTRS[i]); if (v) p.push(v); }
  var link = card.querySelector('a[href*="/products/"]');
  if (link) p.push(link.getAttribute('href') || '');
  var titleEl = card.querySelector('.product-card__title, .product-card__name, h3, h2');
  if (titleEl) p.push(titleEl.textContent || '');
  var chips = card.querySelectorAll('.product-card__badge-list--bottom a, .product-card__badge-list--bottom span');
  for (var ci = 0; ci < chips.length; ci++) p.push(chips[ci].textContent || '');
  /* A prebuilt with a spec rail no longer prints its own badges in the badge list; the rail carries them */
  var prail = card.querySelector('.pc-rail[data-src]');
  if (prail) p.push(prail.getAttribute('data-src') || '');
  card._bsrc = p.join(' ').replace(/\s+/g,' ').trim();
  return card._bsrc;
}

function brtFindRule(text, rules) {
  text = String(text||'').replace(/\+/g,' plus ');
  for (var i = 0; i < rules.length; i++) { if (rules[i].re.test(text)) return rules[i]; }
  return null;
}

/* SPEC-PRIORITY source: reads ONLY the real Shopify spec badge chips
   (the same data the mobile layout renders). This is the source of truth
   for GPU/CPU/RAM. Stale product tags/handles/titles are NOT included here
   so they can never override the real spec. */
function brtGetSpecSrc(card) {
  if (card._bspec) return card._bspec;
  /* A prebuilt with a spec rail: the rail already holds the specs as plain text */
  var prail = card.querySelector('.pc-rail[data-spec]');
  if (prail) {
    var rs = (prail.getAttribute('data-spec') || '').replace(/\s+/g,' ').trim();
    if (rs) { card._bspec = rs; return rs; }
  }
  var p = [];
  var chips = card.querySelectorAll('.product-card__badge-list--bottom a, .product-card__badge-list--bottom span');
  for (var ci = 0; ci < chips.length; ci++) p.push(chips[ci].textContent || '');
  var out = p.join(' ').replace(/\s+/g,' ').trim();
  if (out) card._bspec = out; /* only cache once chips exist, else retry next pass */
  return out;
}

/* Find a rule preferring the real spec badges, falling back to the full blob. */
function brtFindRuleSpec(card, rules) {
  var spec = brtGetSpecSrc(card);
  var hit = spec ? brtFindRule(spec, rules) : null;
  if (hit) return hit;
  return brtFindRule(brtGetSrc(card), rules);
}

function brtFindRarity(card) {
  var text = ' ' + brtGetSrc(card).toLowerCase().replace(/[^a-z0-9+]+/g,' ') + ' ';
  for (var i = 0; i < RARITY_ORDER_DESC.length; i++) {
    var t = RARITY_ORDER_DESC[i];
    if (text.indexOf(' brutech rarity '+t+' ')!==-1 || text.indexOf(' rarity '+t+' ')!==-1 || text.indexOf(' '+t+' ')!==-1) return t;
  }
  return null;
}

function brtExtractRam(text) {
  var raw = String(text||'');
  var m = raw.match(/(\d{1,3})\s*GB\s+DDR[45]/i) || raw.match(/DDR[45]\s*(\d{1,3})\s*GB/i);
  var gb = m ? parseInt(m[1],10) : 16;
  var ddr = (raw.match(/DDR[45]/i)||['DDR5'])[0].toUpperCase();
  var score = gb >= 64 ? 82 : gb >= 32 ? 65 : gb >= 16 ? 45 : 30;
  return { display: gb+'GB '+ddr, score: score };
}

function brtEsc(v) {
  return String(v||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

/* Safe section heading check — reads only headings, not product card JSON */
function brtSectionHas(section, re) {
  var els = section.querySelectorAll('h1,h2,h3,h4,h5,h6,p,label,span[class*="heading"]');
  for (var i = 0; i < Math.min(els.length, 30); i++) {
    if (els[i].querySelectorAll('product-card,.product-card').length) continue;
    if (re.test(els[i].textContent||'')) return true;
  }
  return false;
}

function brtGetUrl(card) {
  var l = card.querySelector('a[href*="/products/"]');
  if (l) return l.getAttribute('href');
  var h = card.getAttribute('handle')||card.getAttribute('data-handle');
  return h ? '/products/'+h : '#';
}

/* Inject a horizontal spec chip strip for non-rarity cards.
   Reads GPU/CPU/RAM from brtGetSrc() — never touches card.textContent. */
function brtBuildSpecChips(card) {
  if (card.querySelector('.brutech-spec-chips')) return;
  if (card.querySelector('.pc-rail')) return; /* the spec rail already shows these */
  var src = brtGetSrc(card);

  var chips = [];
  var gpu = brtFindRuleSpec(card, GPU_RULES);
  var cpu = brtFindRuleSpec(card, CPU_RULES);
  var ram = brtExtractRam(brtGetSpecSrc(card) || src);

  /* Storage — match "512GB NVMe", "1TB Gen4 NVMe SSD", "2TB SSD" etc. */
  var storeM = src.match(/(\d+(?:\.\d+)?)\s*(TB|GB)\s*(?:Gen\d\s*)?(?:NVMe|SSD|HDD|M\.2)/i);
  var storage = storeM ? (storeM[1]+storeM[2]+' '+(src.match(/NVMe/i)?'NVMe':src.match(/SSD/i)?'SSD':'HDD')) : null;

  /* Screen size — laptops */
  var screenM = src.match(/(\d{2}(?:\.\d)?)["\u201d]\s*(?:laptop|screen|display)?/i) ||
                src.match(/(\d{2}(?:\.\d)?)\s*(?:inch|in\.)/i);
  var screen = screenM ? screenM[1]+'\u2033' : null;

  if (gpu)     chips.push({ cls:'chip--nvidia chip--gpu',  label: gpu.display,   isCpu:false,
                             cls2: /amd|radeon|rx\s*\d/i.test(gpu.display)?'chip--amd chip--gpu':'chip--nvidia chip--gpu' });
  if (cpu)     chips.push({ cls: /intel|core/i.test(cpu.display)?'chip--intel chip--cpu':'chip--amd chip--cpu', label: cpu.display });
  if (ram.display !== '16GB DDR5' || src.match(/\d+GB\s+DDR/i))
               chips.push({ cls:'chip--ram', label: ram.display });
  if (storage) chips.push({ cls:'chip--storage', label: storage });
  if (screen)  chips.push({ cls:'chip--screen', label: screen });

  if (!chips.length) return;

  var wrap = document.createElement('div');
  wrap.className = 'brutech-spec-chips';
  chips.forEach(function(c) {
    var chip = document.createElement('span');
    chip.className = 'brutech-spec-chip ' + (c.cls2 || c.cls);
    chip.textContent = c.label;
    wrap.appendChild(chip);
  });

  /* Insert between figure and info section */
  var info = card.querySelector('.product-card__info,.product-card__details,.product-card__content,.product-card__aside');
  var fig  = card.querySelector('.product-card__figure');
  if (fig && fig.nextSibling) {
    fig.parentNode.insertBefore(wrap, fig.nextSibling);
  } else if (info) {
    info.insertBefore(wrap, info.firstChild);
  } else {
    card.appendChild(wrap);
  }

  /* Mark card so CSS can hide the theme's duplicate badge list */
  card.classList.add('brutech-has-chips');
}


/* ══════════════════════════════════════════════════════════════
   LOADOUT CARDS
══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var SKIP_RE = /creator|workstation|studio|proart|da.vinci|dali|van.gogh|pollock|warhol|kandinsky|picasso|banksy|michelangelo|degas|munch|seurat|threadripper|darwin|hawking|newton|einstein|edison|office.pc|office-pc|business.desktop|business.pc|lynx|andromeda|hydra|pegasus|centaurus/;

  function makeStat(label, val, icon) {
    return '<span class="brutech-stat" title="'+brtEsc(label+': '+val)+'">'
      +'<span class="brutech-stat-icon">'+icon+'</span>'
      +'<span class="brutech-stat-copy">'
      +'<span class="brutech-stat-label">'+brtEsc(label)+'</span>'
      +'<span class="brutech-stat-value">'+brtEsc(val)+'</span>'
      +'</span></span>';
  }

  function makeMeta(stats) {
    return '<div class="brutech-loadout-meta" aria-label="Loadout summary">'
      +'<span class="brutech-meta-best-for"><b>Best For</b><em>'+brtEsc(stats.bestFor)+'</em></span>'
      +'<span class="brutech-meta-power"><b>Power</b><em>LVL '+Math.round(stats.buildScore)+'</em></span>'
      +'<span class="brutech-meta-target"><b>Target</b><em>'+brtEsc(stats.resolution)+'</em></span>'
      +'<span class="brutech-meta-value brutech-meta-value"><b>Value</b><em>'+brtEsc(stats.value)+'</em></span>'
      +'</div>';
  }

  function getStats(card, rarity) {
    var text = brtGetSrc(card);
    var profile = RARITY_PROFILES[rarity] || RARITY_PROFILES.common;
    var gpuInfo = brtFindRuleSpec(card, GPU_RULES) || { display:profile.gpuFallback, score:45, target:profile.target, bestFor:profile.bestFor };
    var cpuInfo = brtFindRuleSpec(card, CPU_RULES) || { display:profile.cpuFallback, score:45 };
    var ramInfo = brtExtractRam(brtGetSpecSrc(card) || text);
    var buildScore = (gpuInfo.score * 0.54) + (cpuInfo.score * 0.31) + (ramInfo.score * 0.10) + ((profile.tierScore||0) * 0.05);
    return {
      gpu: gpuInfo.display, cpu: cpuInfo.display, ram: ramInfo.display,
      gpuScore: gpuInfo.score, cpuScore: cpuInfo.score, ramScore: ramInfo.score,
      buildScore: buildScore, value: profile.value,
      bestFor: gpuInfo.bestFor || profile.bestFor,
      resolution: gpuInfo.target || profile.target
    };
  }

  function buildLoadoutUI(card, rarity) {
    var stats = getStats(card, rarity);
    var url = brtGetUrl(card);
    var label = RARITY_LABELS[rarity] || '◆ LOADOUT';

    var info = card.querySelector('.product-card__info,.product-card__details,.product-card__content,.product-card__aside') || card;
    var fig = card.querySelector('.product-card__figure') || card;

    /* Remove any stale injected elements */
    ['.brutech-rarity-badge','.brutech-stat-bar','.brutech-loadout-meta','.brutech-select-loadout','.brutech-selected-check','.brutech-bottom-glow'].forEach(function(s) {
      card.querySelectorAll(s).forEach(function(e) { e.remove(); });
    });

    fig.style.position = 'relative';

    var badge = document.createElement('div');
    badge.className = 'brutech-rarity-badge'; badge.textContent = label;
    fig.appendChild(badge);

    /* The prebuilt spec rail replaces the stat bar, so the card does not show the same specs twice */
    if (!card.querySelector('.pc-rail')) {
      var bar = document.createElement('div');
      bar.className = 'brutech-stat-bar';
      bar.innerHTML = makeStat('GPU',stats.gpu,'▣') + makeStat('CPU',stats.cpu,'◈') + makeStat('RAM',stats.ram,'▰') + makeStat('VALUE',stats.value,'◆');
      fig.appendChild(bar);
    }

    var glow = document.createElement('div'); glow.className = 'brutech-bottom-glow';
    fig.appendChild(glow);

    var chk = document.createElement('div'); chk.className = 'brutech-selected-check'; chk.innerHTML = '✓';
    card.appendChild(chk);

    /* The prebuilt spec rail already says what the PC is, so the Best For / Power / Target / Value tiles are left off */
    if (!card.querySelector('.pc-rail')) {
      var metaWrap = document.createElement('div'); metaWrap.innerHTML = makeMeta(stats);
      var metaEl = metaWrap.firstChild;
      metaEl.setAttribute('data-rarity', rarity);
      info.appendChild(metaEl);
    }

    var cta = document.createElement('a');
    cta.className = 'brutech-select-loadout'; cta.href = url; cta.textContent = 'SELECT LOADOUT';
    cta.addEventListener('click', function(e) {
      e.preventDefault(); card.classList.add('brutech-is-selected');
      setTimeout(function() { window.location.href = url; }, 280);
    });
    info.appendChild(cta);
  }

  function decorateCard(card) {
    if (!card || !card.classList) return;
    if (card.dataset.bdone === '1') return;

    var src = brtGetSrc(card).toLowerCase();
    if (SKIP_RE.test(src)) { card.dataset.bdone = '1'; return; }

    var rarity = brtFindRarity(card);
    for (var ti = 0; ti < RARITY_TIERS.length; ti++) card.classList.remove('brutech-rarity-'+RARITY_TIERS[ti]);
    card.classList.add('brutech-loadout-card');

    if (rarity) {
      card.classList.add('brutech-rarity', 'brutech-rarity-'+rarity);
      var prailT = card.querySelector('.pc-rail');
      if (prailT) prailT.setAttribute('data-tier', rarity);
      buildLoadoutUI(card, rarity);
    } else {
      /* Non-rarity card (laptop, accessory, etc.) — detect type and add spec chips */
      var srcLow = brtGetSrc(card).toLowerCase();
      if (/laptop|notebook|\bnitro\b|\bhelios\b|\bpredator\b|asus.*rog|asus.*tuf|\btuf\b|hp\s*omen|hp\s*victus|lenovo.*legion|msi.*gaming|razer|\bgf\d{3}\b|acer\s*\w/i.test(srcLow)) {
        card.classList.add('brutech-laptop-card');
      }
      brtBuildSpecChips(card);
    }
    card.dataset.bdone = '1';
    var titleEl = card.querySelector('.product-card__title, .product-card__name');
    if (titleEl && /^Brutech\s*\|/i.test(titleEl.textContent))
      titleEl.textContent = titleEl.textContent.replace(/^Brutech\s*\|\s*/i, '');

    /* Colour spec chips */
    var chips = card.querySelectorAll('.product-card__badge-list--bottom a, .product-card__badge-list--bottom span');
    for (var ci = 0; ci < chips.length; ci++) {
      var chip = chips[ci]; var txt = chip.textContent.toLowerCase();
      chip.classList.remove('badge--intel','badge--nvidia','badge--amd','badge--other','badge--full');
      if (/intel|core ultra|core i[3579]/.test(txt)) { chip.classList.add('badge--intel','badge--full'); }
      else if (/nvidia|geforce|rtx|gtx/.test(txt))   { chip.classList.add('badge--nvidia','badge--full'); }
      else if (/amd|ryzen|radeon|rx\s*\d/.test(txt)) { chip.classList.add('badge--amd','badge--full'); }
      else { chip.classList.add('badge--other'); }
    }

  }

  /* Process ONE card per animation frame — prevents jank */
  function processQueue(cards, idx) {
    if (idx >= cards.length) return;
    try { decorateCard(cards[idx]); } catch(e) { console.warn('[Brutech]',e); }
    requestAnimationFrame(function() { processQueue(cards, idx+1); });
  }

  function initAllCards() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('product-card, .product-card'));
    if (cards.length) requestAnimationFrame(function() { processQueue(cards, 0); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initAllCards, 150);
      new MutationObserver(function(mutations) {
        var nc = [];
        for (var mi = 0; mi < mutations.length; mi++) {
          var added = mutations[mi].addedNodes;
          for (var ni = 0; ni < added.length; ni++) {
            var node = added[ni];
            if (!node || node.nodeType !== 1) continue;
            if (node.matches && (node.matches('product-card')||node.matches('.product-card'))) nc.push(node);
            else if (node.querySelectorAll) {
              var f = node.querySelectorAll('product-card, .product-card');
              for (var fi = 0; fi < f.length; fi++) nc.push(f[fi]);
            }
          }
        }
        if (!nc.length) return;
        clearTimeout(_obsTimer);
        _obsTimer = setTimeout(function() { requestAnimationFrame(function() { processQueue(nc, 0); }); }, 600);
      }).observe(document.querySelector('main')||document.querySelector('#MainContent')||document.body, { childList:true, subtree:true });
    });
  } else {
    setTimeout(initAllCards, 150);
    new MutationObserver(function(mutations) {
      var nc = [];
      for (var mi = 0; mi < mutations.length; mi++) {
        var added = mutations[mi].addedNodes;
        for (var ni = 0; ni < added.length; ni++) {
          var node = added[ni];
          if (!node || node.nodeType !== 1) continue;
          if (node.matches && (node.matches('product-card')||node.matches('.product-card'))) nc.push(node);
          else if (node.querySelectorAll) {
            var f = node.querySelectorAll('product-card, .product-card');
            for (var fi = 0; fi < f.length; fi++) nc.push(f[fi]);
          }
        }
      }
      if (!nc.length) return;
      clearTimeout(_obsTimer);
      _obsTimer = setTimeout(function() { requestAnimationFrame(function() { processQueue(nc, 0); }); }, 600);
    }).observe(document.querySelector('main')||document.querySelector('#MainContent')||document.body, { childList:true, subtree:true });
  }
})();


/* ══════════════════════════════════════════════════════════════
   CATEGORY CARD IDENTITY — Creator / Threadripper / Office
══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var ARTISTS = { 'da-vinci':{name:'Da Vinci',movement:'Renaissance'}, 'dali':{name:'Dali',movement:'Surrealism'}, 'van-gogh':{name:'Van Gogh',movement:'Post-Impressionist'}, 'pollock':{name:'Pollock',movement:'Abstract Expr.'}, 'warhol':{name:'Warhol',movement:'Pop Art'}, 'kandinsky':{name:'Kandinsky',movement:'Abstract Art'}, 'picasso':{name:'Picasso',movement:'Cubism'}, 'banksy':{name:'Banksy',movement:'Street Art'}, 'michelangelo':{name:'Michelangelo',movement:'High Renaissance'}, 'degas':{name:'Degas',movement:'Impressionism'}, 'munch':{name:'Munch',movement:'Expressionism'}, 'seurat':{name:'Seurat',movement:'Pointillism'} };
  var SCIENTISTS = { 'darwin':{name:'Darwin',formula:'Natural Selection'}, 'hawking':{name:'Hawking',formula:'S = A/4'}, 'newton':{name:'Newton',formula:'F = ma'}, 'einstein':{name:'Einstein',formula:'E = mc²'}, 'edison':{name:'Edison',formula:'1% inspiration'} };
  var OFFICE_SERIES = { 'lynx':{name:'Lynx'}, 'andromeda':{name:'Andromeda'}, 'hydra':{name:'Hydra'}, 'pegasus':{name:'Pegasus'}, 'centaurus':{name:'Centaurus'} };

  function norm(v) { return String(v||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,''); }

  /* Uses same safe read pattern as brtGetSrc — no card.textContent */
  function getSafeSrc(card) {
    var p = [];
    var ATTRS = ['handle','data-handle','data-product-title','data-product-type','data-product-tags','aria-label','title','class'];
    for (var i = 0; i < ATTRS.length; i++) { var v = card.getAttribute(ATTRS[i]); if (v) p.push(v); }
    var link = card.querySelector('a[href*="/products/"]');
    if (link) p.push(link.getAttribute('href')||'');
    var titleEl = card.querySelector('.product-card__title,.product-card__name,h2,h3');
    if (titleEl) p.push(titleEl.textContent||'');
    var imgs = card.querySelectorAll('img');
    for (var ii = 0; ii < imgs.length; ii++) { var alt = imgs[ii].getAttribute('alt'); if (alt) p.push(alt); }
    return p.join(' ');
  }

  function srcHas(src, words) {
    var n = norm(src);
    return words.some(function(w) { return n.indexOf(norm(w)) !== -1; });
  }

  function findMatch(src, data) {
    var n = norm(src);
    for (var k in data) {
      if (!Object.prototype.hasOwnProperty.call(data,k)) continue;
      if (n.indexOf(k) !== -1 || n.indexOf(norm(data[k].name)) !== -1) return data[k];
    }
    return null;
  }

  function clearRarity(card) {
    ['common','uncommon','rare','epic','legendary','mystic','divine','celestial','eldritch','mythic','mythical'].forEach(function(t) { card.classList.remove('brutech-rarity-'+t); });
    if (card.dataset) card.dataset.brutechRarity = 'category';
  }

  function setCta(card, label) {
    var cta = card.querySelector('.brutech-select-loadout');
    if (cta) cta.textContent = label;
  }

  function applyCreator(card) {
    var src = getSafeSrc(card);
    if (!srcHas(src,['creator','workstation','studio','da vinci','dali','van gogh','pollock','warhol','kandinsky','picasso','banksy','michelangelo','degas','munch','seurat'])) return;
    if (srcHas(src,['threadripper','darwin','hawking','newton','einstein','edison'])) return;
    if (card.dataset.brutechCreatorDone) return;
    card.dataset.brutechCreatorDone = '1';
    clearRarity(card);
    card.classList.add('brutech-creator-card','brutech-loadout-card');
    var artist = findMatch(src, ARTISTS);
    var fig = card.querySelector('.product-card__figure')||card; fig.style.position = 'relative';
    if (!fig.querySelector('.brutech-artist-badge')) { var b = document.createElement('div'); b.className='brutech-artist-badge'; b.textContent=artist?artist.name:'MASTER CLASS'; fig.appendChild(b); }
    if (artist && !fig.querySelector('.brutech-artist-movement')) { var m = document.createElement('div'); m.className='brutech-artist-movement'; m.textContent=artist.movement; fig.appendChild(m); }
    setCta(card, 'ENTER STUDIO');
    brtBuildSpecChips(card);
  }

  function applyThreadripper(card) {
    var src = getSafeSrc(card);
    if (!srcHas(src,['threadripper','darwin','hawking','newton','einstein','edison'])) return;
    if (card.dataset.brutechThreadripperDone) return;
    card.dataset.brutechThreadripperDone = '1';
    clearRarity(card);
    card.classList.add('brutech-threadripper-card','brutech-loadout-card');
    var sci = findMatch(src, SCIENTISTS);
    var fig = card.querySelector('.product-card__figure')||card; fig.style.position = 'relative';
    if (!fig.querySelector('.brutech-scientist-badge')) { var b = document.createElement('div'); b.className='brutech-scientist-badge'; b.textContent=sci?sci.name:'HEAVY MACHINE'; fig.appendChild(b); }
    if (sci && !fig.querySelector('.brutech-formula-tag')) { var f = document.createElement('div'); f.className='brutech-formula-tag'; f.textContent=sci.formula; fig.appendChild(f); }
    setCta(card, 'DEPLOY SYSTEM');
    brtBuildSpecChips(card);
  }

  function applyOffice(card) {
    var src = getSafeSrc(card);
    if (!srcHas(src,['office pc','office-pc','office series','business desktop','business pc','lynx','andromeda','hydra','pegasus','centaurus'])) return;
    if (srcHas(src,['creator','workstation','threadripper'])) return;
    if (card.dataset.brutechOfficeDone) return;
    card.dataset.brutechOfficeDone = '1';
    clearRarity(card);
    card.classList.add('brutech-office-card','brutech-loadout-card');
    var pc = findMatch(src, OFFICE_SERIES);
    var fig = card.querySelector('.product-card__figure')||card; fig.style.position = 'relative';
    if (!fig.querySelector('.brutech-office-badge')) { var b = document.createElement('div'); b.className='brutech-office-badge'; b.textContent=pc?pc.name:'OFFICE SERIES'; fig.appendChild(b); }
    if (!fig.querySelector('.brutech-office-series')) { var s = document.createElement('div'); s.className='brutech-office-series'; s.textContent='RELIABLE SYSTEM'; fig.appendChild(s); }
    setCta(card, 'VIEW SYSTEM');
    brtBuildSpecChips(card);
  }

  function applyCategory(card) {
    try { applyThreadripper(card); applyOffice(card); applyCreator(card); } catch(e) { console.warn('[Brutech]',e); }
  }

  function initAll() {
    try { document.querySelectorAll('product-card, .product-card').forEach(applyCategory); } catch(e) { console.warn('[Brutech]',e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initAll, 200);
      new MutationObserver(function(mutations) {
        var nc = [];
        mutations.forEach(function(m) {
          m.addedNodes.forEach(function(node) {
            if (!node || node.nodeType !== 1) return;
            if (node.matches && (node.matches('product-card')||node.matches('.product-card'))) nc.push(node);
            else if (node.querySelectorAll) node.querySelectorAll('product-card,.product-card').forEach(function(n) { nc.push(n); });
          });
        });
        if (!nc.length) return;
        clearTimeout(_catTimer);
        _catTimer = setTimeout(function() { nc.forEach(applyCategory); }, 800);
      }).observe(document.querySelector('main')||document.querySelector('#MainContent')||document.body, { childList:true, subtree:true });
    });
  } else {
    setTimeout(initAll, 200);
    new MutationObserver(function(mutations) {
      var nc = [];
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && (node.matches('product-card')||node.matches('.product-card'))) nc.push(node);
          else if (node.querySelectorAll) node.querySelectorAll('product-card,.product-card').forEach(function(n) { nc.push(n); });
        });
      });
      if (!nc.length) return;
      clearTimeout(_catTimer);
      _catTimer = setTimeout(function() { nc.forEach(applyCategory); }, 800);
    }).observe(document.querySelector('main')||document.querySelector('#MainContent')||document.body, { childList:true, subtree:true });
  }
})();


/* ══════════════════════════════════════════════════════════════
   MEGA MENU RPG
══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var FACTIONS = {
    gaming:      { tag:'⚔️ GAMING ARSENAL', desc:'Battle-tested. RTX 50-Series.', cta:'CHOOSE YOUR LOADOUT', tiers:[{label:'◆ Common',cls:'chip-common'},{label:'◆ Uncommon',cls:'chip-uncommon'},{label:'◆ Rare',cls:'chip-rare'},{label:'◆ Epic',cls:'chip-epic'},{label:'◆ Legendary',cls:'chip-legendary'},{label:'◆ Mystic',cls:'chip-mystic'},{label:'◆ Divine',cls:'chip-divine'},{label:'★ Mythical',cls:'chip-mythical'}] },
    invisio:     { tag:'⚪ INVISIO', desc:'Zero cables. Full power.', cta:'ENTER THE PHANTOM', tiers:[{label:'◆ Common',cls:'chip-common'},{label:'◆ Uncommon',cls:'chip-uncommon'},{label:'◆ Rare',cls:'chip-rare'},{label:'◆ Epic',cls:'chip-epic'},{label:'◆ Legendary',cls:'chip-legendary'}] },
    zeroram:     { tag:'⚡ ZERORAM', desc:'Bring your own DDR5.', cta:'CLAIM YOUR CHASSIS', tiers:[{label:'◆ Common',cls:'chip-common'},{label:'◆ Uncommon',cls:'chip-uncommon'},{label:'◆ Rare',cls:'chip-rare'},{label:'◆ Epic',cls:'chip-epic'},{label:'◆ Legendary',cls:'chip-legendary'},{label:'◆ Mystic',cls:'chip-mystic'},{label:'★ Mythical',cls:'chip-mythical'}] },
    creator:     { tag:'🎨 MASTER CLASS', desc:'Named after the greats.', cta:'ENTER MASTER CLASS', names:['Da Vinci','Van Gogh','Pollock','Picasso','Kandinsky','Warhol','Banksy','Michelangelo'] },
    threadripper:{ tag:'🔬 HEAVY MACHINE', desc:'Hypothesis: nothing is fast enough.', cta:'DEPLOY HEAVY MACHINE', names:['Darwin','Edison','Newton','Hawking','Einstein'] },
    office:      { tag:'🖥️ OFFICE SERIES', desc:'Quiet. Reliable. Always ready.', cta:'VIEW OFFICE SERIES', names:['Lynx','Andromeda','Hydra','Pegasus','Centaurus'] },
    accessories: { tag:'🎮 ACCESSORIES', desc:'Gear up your setup.', cta:'SHOP ACCESSORIES' },
    lorgar:      { tag:'⚡ LORGAR TRIBE', desc:'Ready to Play. Statistically enhanced.', cta:'ENTER THE TRIBE', tiers:[{label:'◆ Advanced',cls:'chip-rare'},{label:'◆ Pro',cls:'chip-epic'},{label:'★ Elite',cls:'chip-legendary'}] },
    simracing:   { tag:'🏁 SIM RACING', desc:'Apex line. Every lap.', cta:'ENTER THE GRID', names:['Cockpits','Wheels','Pedals','Shifters','Handbrakes'] }
  };

  function detectFaction(card) {
    var h = card.querySelector('a.h5, a[href*="/collections/"]');
    var c = (h ? (h.getAttribute('href')||'')+(h.textContent||'') : '').toLowerCase();
    if (c.indexOf('sim-racing')!==-1||c.indexOf('sim racing')!==-1||c.indexOf('cockpit')!==-1||c.indexOf('racing-wheel')!==-1) return 'simracing';
    if (c.indexOf('lorgar')!==-1) return 'lorgar';
    if (c.indexOf('accessor')!==-1||c.indexOf('monitor')!==-1) return 'accessories';
    if (c.indexOf('threadripper')!==-1) return 'threadripper';
    if (c.indexOf('creator')!==-1||c.indexOf('workstation')!==-1) return 'creator';
    if (c.indexOf('office')!==-1) return 'office';
    if (c.indexOf('invisio')!==-1) return 'invisio';
    if (c.indexOf('zeroram')!==-1) return 'zeroram';
    return 'gaming';
  }

  function enhanceCard(card) {
    if (card.dataset.brutechFaction) return;
    var fk = detectFaction(card);
    var faction = FACTIONS[fk] || FACTIONS.gaming;
    card.dataset.brutechFaction = fk;
    card.setAttribute('data-faction', fk);

    /* Portrait wrap */
    var img = card.querySelector('.mega-menu__column-image');
    if (img && !img.closest('.brutech-card-portrait')) {
      var portrait = document.createElement('div'); portrait.className = 'brutech-card-portrait';
      img.parentNode.insertBefore(portrait, img); portrait.appendChild(img);
      var ey = document.createElement('div'); ey.className = 'brutech-faction-eyebrow';
      ey.innerHTML = '<span class="brutech-faction-dot"></span><span class="brutech-faction-tag">'+faction.tag+'</span>';
      portrait.appendChild(ey);
      var content = document.createElement('div'); content.className = 'brutech-card-content';
      while (card.children.length > 0 && card.children[0] !== portrait) content.appendChild(card.children[0]);
      while (card.children.length > 1) content.appendChild(card.children[1]);
      card.appendChild(content);
    }

    /* Faction desc */
    var cardContent = card.querySelector('.brutech-card-content') || card;
    if (!cardContent.querySelector('.brutech-faction-desc') && faction.desc) {
      var titleLink = cardContent.querySelector('a.h5');
      if (titleLink) { var desc = document.createElement('span'); desc.className='brutech-faction-desc'; desc.textContent=faction.desc; titleLink.insertAdjacentElement('afterend',desc); }
    }

    /* Tier chips or name chips */
    ['.brutech-mega-tiers','.brutech-mega-names'].forEach(function(s) { var e = cardContent.querySelector(s); if (e) e.remove(); });
    var ul = cardContent.querySelector('ul');
    if (faction.tiers) {
      var wrap = document.createElement('div'); wrap.className = 'brutech-mega-tiers';
      faction.tiers.forEach(function(t) { var chip = document.createElement('span'); chip.className='brutech-mega-tier-chip '+t.cls; chip.textContent=t.label; wrap.appendChild(chip); });
      if (ul) cardContent.insertBefore(wrap,ul); else cardContent.appendChild(wrap);
    } else if (faction.names) {
      var wrap2 = document.createElement('div'); wrap2.className = 'brutech-mega-names';
      faction.names.forEach(function(n) { var chip = document.createElement('span'); chip.className='brutech-mega-name-chip'; chip.textContent=n.toUpperCase(); wrap2.appendChild(chip); });
      if (ul) cardContent.insertBefore(wrap2,ul); else cardContent.appendChild(wrap2);
    }

    /* CTA text */
    if (faction.cta && ul) {
      var lastLi = ul.querySelector('li:last-child');
      if (lastLi) { var a = lastLi.querySelector('a'); if (a && !a.dataset.brutechCtaSet) { a.dataset.brutechCtaSet='1'; a.textContent=faction.cta+' →'; } }
    }

    /* Corner brackets */
    if (!card.querySelector('.brutech-corner')) {
      ['tl','tr','bl','br'].forEach(function(pos) { var c = document.createElement('span'); c.className='brutech-corner brutech-corner-'+pos; card.appendChild(c); });
    }

    /* Mouse glow */
    if (!card.dataset.brutechMouse) {
      card.dataset.brutechMouse = '1';
      card.addEventListener('mousemove', function(e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--mx',(((e.clientX-r.left)/r.width)*100).toFixed(1)+'%');
        card.style.setProperty('--my',(((e.clientY-r.top)/r.height)*100).toFixed(1)+'%');
      });
    }
  }

  function initScrollHeader() {
    var header = document.getElementById('shopify-section-header'); if (!header) return;
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function() { header.classList.toggle('is-scrolled', window.scrollY > 40); ticking = false; });
    }, { passive: true });
  }

  function init() {
    try {
      document.querySelectorAll('.mega-menu__nav > li').forEach(enhanceCard);
      initScrollHeader();
      /* Narrow observer — only watches the header, only childList */
      var headerEl = document.querySelector('#shopify-section-header');
      if (headerEl) {
        new MutationObserver(function() {
          headerEl.querySelectorAll('.mega-menu__nav > li:not([data-brutech-faction])').forEach(enhanceCard);
        }).observe(headerEl, { childList:true, subtree:true });
      }
    } catch(e) { console.warn('[Brutech] Mega menu error:', e); }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();


/* ══════════════════════════════════════════════════════════════
   HOME PAGE RPG
══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var isHome = window.location.pathname==='/'||window.location.pathname==='/index'||(window.Shopify&&window.Shopify.pageType==='index');
  if (!isHome) return;
  document.body.classList.add('template-index');

  var HOME_FACTIONS = {
    gaming:      { tag:'⚔️ GAMING ARSENAL', desc:'Battle-tested. RTX 50-Series.', cta:'CHOOSE LOADOUT →' },
    creator:     { tag:'🎨 MASTER CLASS',   desc:'Named after the greats.',        cta:'ENTER STUDIO →'  },
    invisio:     { tag:'⚪ INVISIO',        desc:'Zero cables. Full power.',       cta:'ENTER PHANTOM →' },
    zeroram:     { tag:'⚡ ZERORAM',        desc:'Bring your own DDR5.',           cta:'CLAIM CHASSIS →' },
    office:      { tag:'🖥️ OFFICE SERIES', desc:'Quiet. Reliable. Always ready.', cta:'VIEW SERIES →'   },
    threadripper:{ tag:'🔬 HEAVY MACHINE',  desc:'Hypothesis: nothing is fast enough.', cta:'DEPLOY MACHINE →' },
    lorgar:      { tag:'⚡ LORGAR TRIBE',   desc:'Ready to Play.',                 cta:'ENTER TRIBE →'  },
    simracing:   { tag:'🏁 SIM RACING',     desc:'Apex line. Every lap.',          cta:'ENTER GRID →'   }
  };

  function initHeroLayer() {
    var hero = document.querySelector('#brutech-slideshow,.brutech-slideshow,[data-section-type="slideshow"],.slideshow,.banner');
    if (!hero || hero.querySelector('.brutech-hero-rpg-layer')) return;
    hero.style.position = 'relative';
    var layer = document.createElement('div'); layer.className = 'brutech-hero-rpg-layer'; hero.appendChild(layer);
    ['tl','tr','bl','br'].forEach(function(pos) { var c = document.createElement('span'); c.className='brutech-hero-corner brutech-hero-corner-'+pos; layer.appendChild(c); });
    var status = document.createElement('div'); status.className = 'brutech-hero-status';
    status.innerHTML = '<span class="brutech-hero-status-dot"></span><span>BRUTECH.SYS · ONLINE</span>';
    layer.appendChild(status);
  }

  function initFactionSelect() {
    document.querySelectorAll('.shopify-section').forEach(function(section) {
      if (!brtSectionHas(section, /product categor|browse by categor/i)) return;
      section.classList.add('brutech-faction-select-section');
      var cardData = [];
      section.querySelectorAll('a[href*="/collections/"]').forEach(function(a) {
        var href = a.getAttribute('href')||'', img = a.querySelector('img');
        var fk = 'gaming';
        if (/threadripper/i.test(href)) fk='threadripper';
        else if (/creator|workstation/i.test(href)) fk='creator';
        else if (/invisio/i.test(href)) fk='invisio';
        else if (/zeroram/i.test(href)) fk='zeroram';
        else if (/office/i.test(href)) fk='office';
        var src = img?(img.getAttribute('src')||img.getAttribute('data-src')||''):'';
        if (src && src.indexOf('width=')===-1) src+=((src.indexOf('?')>-1?'&':'?')+'width=400');
        var te = a.querySelector('p,strong,[class*="title"],h3,h4');
        cardData.push({href:href,src:src,alt:img?(img.getAttribute('alt')||''):'',fk:fk,title:te?te.textContent.trim():''});
      });
      if (!cardData.length) return;
      var html = '<div class="brutech-faction-select-heading"><div class="brutech-eyebrow">// SELECT YOUR FACTION</div><h2>Choose Your <span>Faction</span></h2></div><div class="brutech-faction-grid">';
      cardData.forEach(function(d,i) {
        var faction = HOME_FACTIONS[d.fk]||HOME_FACTIONS.gaming;
        html += '<a href="'+d.href+'" class="brutech-faction-card brutech-reveal brutech-reveal-delay-'+Math.min(i+1,6)+'" data-faction="'+d.fk+'">';
        html += '<div class="brutech-fc-img">';
        if (d.src) html += '<img src="'+d.src+'" alt="'+brtEsc(d.alt)+'" loading="lazy">';
        html += '<div class="brutech-fc-tag"><span class="brutech-fc-dot"></span>'+faction.tag+'</div></div>';
        html += '<div class="brutech-fc-body"><div class="brutech-fc-name">'+(d.title||faction.tag)+'</div><div class="brutech-fc-desc">'+faction.desc+'</div><div class="brutech-fc-cta">'+faction.cta+'</div></div></a>';
      });
      html += '</div>';
      var inner = section.querySelector('[class*="page-width"],[class*="container"],[class*="section-padding"]')||section;
      inner.innerHTML = html;
    });
  }

  function addEyebrow(section, text, heading) {
    if (!heading || heading.dataset.brutechDone) return;
    heading.dataset.brutechDone = '1';
    var ew = document.createElement('div'); ew.textContent = text;
    ew.style.cssText = "font-family:'Share Tech Mono',monospace;font-size:9px;letter-spacing:3.5px;text-transform:uppercase;color:rgba(39,188,221,0.6);margin-bottom:6px;";
    heading.parentNode.insertBefore(ew, heading);
  }

  function initBestSellers() {
    document.querySelectorAll('.shopify-section').forEach(function(section) {
      if (!brtSectionHas(section, /best sell|top picks/i)) return;
      section.classList.add('brutech-loadouts-section');
      addEyebrow(section,'// FEATURED LOADOUTS',section.querySelector('h2,.section-heading'));
    });
  }

  function initBlogSection() {
    document.querySelectorAll('.shopify-section').forEach(function(section) {
      if (!brtSectionHas(section, /latest news|from the blog/i)) return;
      section.classList.add('brutech-intel-section');
      addEyebrow(section,'// INTELLIGENCE FEED',section.querySelector('h2'));
    });
  }

  function initScrollReveal() {
    if (!window.IntersectionObserver) return;
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { if (e.isIntersecting) { e.target.classList.add('brutech-revealed'); obs.unobserve(e.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.brutech-reveal').forEach(function(el) { obs.observe(el); });
  }

  function initHomeRPG() {
    try {
      initHeroLayer();
      initFactionSelect();
      initBestSellers();
      initBlogSection();
      initScrollReveal();
      setTimeout(initScrollReveal, 300);
    } catch(e) { console.warn('[Brutech] initHomeRPG error:', e); }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initHomeRPG); } else { initHomeRPG(); }
})();


/* ══════════════════════════════════════════════════════════════
   FOOTER FACTION IDENTITY
══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  function initFooter() {
    var footerSection = document.querySelector('[id*="__footer"]');
    if (!footerSection || footerSection.dataset.brutechFooterDone) return;
    footerSection.dataset.brutechFooterDone = '1';
    var firstCol = footerSection.querySelector('[class*="footer__column"],[class*="footer__block"],[class*="footer__section"]');
    if (!firstCol) return;
    var faction = document.createElement('div'); faction.className = 'brutech-footer-faction';
    faction.innerHTML = '<span class="brutech-footer-faction-dot"></span><span class="brutech-footer-faction-tag">⚔️ BRUTECH · SA FACTION</span><span class="brutech-footer-status">// SYSTEM ONLINE</span>';
    firstCol.insertBefore(faction, firstCol.firstChild);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initFooter); } else { initFooter(); }
})();


/* ══════════════════════════════════════════════════════════════
   PAGE TRANSITION — SECTOR LOADING
══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (!document.body) return;

  var MSGS = ['Loading Sector...','Deploying Assets...','Syncing Loadout...','Entering Zone...','Calibrating HUD...','Syncing Inventory...','Opening Portal...','Deploying Loadout...','Initializing Quest...','Preparing Battle Station...','Booting Game Engine...','Summoning Loot...','Buffing FPS...','Nerfing Lag...','Rolling for Loot...','Petting the GPU...','Feeding the RGB...','Downloading More RAM...','Taming the Cable Monster...','Press F to Boot...'];

  var overlay = document.createElement('div');
  overlay.className = 'brt-transition-overlay';
  overlay.innerHTML = '<div class="brt-transition-grid"></div>'
    +'<div class="brt-transition-scan"></div>'
    +'<div class="brt-transition-label" id="brt-tr-label">Loading Sector...</div>'
    +'<div class="brt-transition-bar-wrap"><div class="brt-transition-bar"></div></div>';
  document.body.appendChild(overlay);

  var labelEl = overlay.querySelector('#brt-tr-label');
  var hideTimer = null;

function show() {
    if (labelEl) labelEl.textContent = MSGS[Math.floor(Math.random()*MSGS.length)];
    clearTimeout(hideTimer);
    overlay.classList.add('is-loading');
    // Safety net only. The real hide happens when the browser actually leaves
    // the page (pagehide) or restores it from the back/forward cache (pageshow).
    hideTimer = setTimeout(function() { overlay.classList.remove('is-loading'); }, 8000);
  }

  function shouldSkip(link, e) {
    var href = link.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return true;
    if (/^(javascript:|mailto:|tel:)/i.test(href)) return true;
    if (link.target === '_blank' || link.hasAttribute('download')) return true;
    if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return true;
    if (href.indexOf('/cdn/') !== -1) return true;
    // Links that open drawers, toggle UI, or filter in place never navigate away
    if (link.closest('[data-open-cart],[aria-controls],[aria-expanded],[data-drawer],[role="button"],facet-filters-form,.facets,.mobile-facets')) return true;
    var url;
    try { url = new URL(link.href, window.location.href); } catch (err) { return true; }
    if (url.origin !== window.location.origin) return true;      // external site
    if (url.pathname === window.location.pathname) return true;  // same page (facets, query changes, anchors)
    return false;
  }

  document.addEventListener('click', function(e) {
    if (e.defaultPrevented) return;
    var link = e.target.closest('a[href]'); if (!link) return;
    if (shouldSkip(link, e)) return;
    show();
  });

  window.addEventListener('pageshow', function() { overlay.classList.remove('is-loading'); clearTimeout(hideTimer); });
  window.addEventListener('popstate', function() { overlay.classList.remove('is-loading'); clearTimeout(hideTimer); });
  window.addEventListener('pagehide', function() { clearTimeout(hideTimer); });
})();


/* ══════════════════════════════════════════════════════════════
   HEADER CART → LOADOUT RENAME
══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  function findCartBtn() {
    return document.querySelector('[data-open-cart],[aria-controls="mini-cart"],a[href="/cart"].header__icon,button.header__icon[aria-label*="art"],.header__icon-wrapper a[href="/cart"]');
  }
  function applyLabel(btn) {
    if (!btn || btn.querySelector('.brt-loadout-label')) return;
    btn.querySelectorAll('.count-bubble,[class*="cart-count"]').forEach(function(el) { el.style.display='none'; });
    var wrap = document.createElement('span');
    wrap.style.cssText = 'display:flex;flex-direction:column;align-items:center;gap:1px;pointer-events:none';
    wrap.innerHTML = '<span class="brt-loadout-label">Loadout</span>';
    btn.appendChild(wrap);
  }
  function init() { applyLabel(findCartBtn()); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function() { setTimeout(init,150); }); } else { setTimeout(init,150); }
  document.addEventListener('cart:updated', init);
})();


/* ══════════════════════════════════════════════════════════════
   HEADER FULL-WIDTH ESCAPE
══════════════════════════════════════════════════════════════ */
(function () {
  function run() {
    try {
      var header = document.querySelector('.shopify-section--header');
      if (!header) return;
      var el = header.parentElement;
      while (el && el !== document.body) {
        var mw = parseFloat(window.getComputedStyle(el).maxWidth);
        if (!isNaN(mw) && mw < window.innerWidth) {
          el.style.setProperty('max-width','none','important');
          el.style.setProperty('width','100%','important');
          el.style.setProperty('padding-left','0','important');
          el.style.setProperty('padding-right','0','important');
          el.style.setProperty('margin-left','0','important');
          el.style.setProperty('margin-right','0','important');
        }
        el = el.parentElement;
      }
    } catch(e) { console.warn('[Brutech] Header escape:', e); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
})();